// Button.js - Shared button component used by Header, Contact and Footer
import React from 'react';

const Button = ({
  href,
  variant = 'primary',
  size = 'md',
  children,
  onClick,
  icon: IconComponent,
  iconPosition = 'right',
  fullWidth = false,
  className = '',
  type = 'button',
  target,
  rel
}) => {
  const baseStyles = `
    inline-flex items-center justify-center gap-2 font-semibold
    transition-all duration-300 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
    ${fullWidth ? 'w-full' : ''}
    whitespace-nowrap
  `;

  const sizeStyles = {
    xs: 'px-3 py-1.5 text-xs rounded-md',
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-5 py-2.5 text-base rounded-lg',
    lg: 'px-6 py-3 text-lg rounded-lg'
  };

  const variants = {
    primary: `bg-primary hover:bg-primaryDark text-white focus-visible:ring-primary shadow-md hover:shadow-lg active:shadow-sm`,
    secondary: `bg-secondary hover:bg-secondaryDark text-black focus-visible:ring-secondary shadow-md hover:shadow-lg active:shadow-sm`,
    outlinePrimary: `bg-transparent border-2 border-primary text-primary hover:bg-primaryLight focus-visible:ring-primary`,
    outlineGray: `bg-transparent border border-lightGray text-darkGray hover:border-mediumGray hover:text-black focus-visible:ring-mediumGray`,
    text: `bg-transparent text-primary hover:text-primaryDark hover:underline focus-visible:ring-primary`,
    dark: `bg-black hover:bg-black/80 text-white focus-visible:ring-black shadow-md hover:shadow-lg active:shadow-sm`
  };

  const iconElement = IconComponent ? <IconComponent size={size === 'lg' ? 20 : size === 'sm' ? 16 : 18} strokeWidth={2.5} /> : null;

  const content = (
    <>
      {iconPosition === 'left' && iconElement}
      {children}
      {iconPosition === 'right' && iconElement}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        onClick={onClick}
        className={`${baseStyles} ${sizeStyles[size]} ${variants[variant]} ${className}`}
        target={target}
        rel={rel}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${sizeStyles[size]} ${variants[variant]} ${className}`}
    >
      {content}
    </button>
  );
};

export default Button;